import React from 'react';
import PageMeta from '../../components/PageMeta';

import Header from '../../components/Header';
import Examples from '../../components/Examples';
import Footer from '../../components/Footer';
import HowItWorks from '../../components/HowItWorks';
import Faq from '../../components/Faq';
import ProductIntro from '../../components/ProductIntro/ProductIntro';
import Generator from '../../components/Generator';

const Home = () => {
    return (
        <>
            <PageMeta page="home" path="/"/>
            <Header/>
            <main>
                <div className="home-creation">
                    <ProductIntro/>
                    <Generator/>
                </div>
                <HowItWorks/>
                <Examples/>
                <Faq/>
            </main>
            <Footer/>
        </>
    );
};

export default Home;
